module.exports = __webpack_public_path__ + "img/logo-1.fccc3196.png";